module.exports = __webpack_public_path__ + "img/UG.8f9e064d.png";